export class PlayTimer {
	private bankedMs = 0;
	private runningSince: number | null = null;

	start(alreadyPlayedMs = 0) {
		this.bankedMs = alreadyPlayedMs;
		this.runningSince = Date.now();
	}

	pause() {
		this.bankedMs = this.getMs();
		this.runningSince = null;
	}

	resume() {
		if (this.runningSince === null) this.runningSince = Date.now();
	}

	getMs() {
		return this.bankedMs + (this.runningSince === null ? 0 : Date.now() - this.runningSince);
	}
}
